<link rel="stylesheet" href="/assets/css/ol.css" />
<div [id]="map_id" class="sidebar-map" style="height:250px;width:350px;">
</div>